import api from './apiClient';

export const racesAPI = {
  getRaces: async (params = {}) => {
    const response = await api.get('/api/races', { params });
    return response.data;
  },
  getRaceById: async (id) => {
    const response = await api.get(`/api/races/${id}`);
    return response.data;
  },
  createRace: async (raceData) => {
    const response = await api.post('/api/races', raceData);
    return response.data;
  },
  updateRace: async (id, raceData) => {
    const response = await api.post(`/api/races/${id}`, raceData);
    return response.data;
  },
  deleteRace: async (id) => {
    await api.post(`/api/races/${id}/delete`, {});
  },
};
